import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import './assets/style/index.scss';

ReactDOM.render(
	<App />,
	document.getElementById('app')
);
